<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>hotel</md-icon>
      </div>
      <h4 class="title">
        Accommodation
      </h4>
      <md-button
        class="md-dense md-primary"
        @click="addAllDays()"
        style="margin-top: 1rem"
      >
        <md-icon>add</md-icon>
        Create all Dates
      </md-button>
      <md-button
        class="md-dense md-primary"
        @click="addDay()"
        style="margin-top: 1rem"
      >
        <md-icon>add</md-icon>
        Add a Reservation
      </md-button>
    </md-card-header>
    <md-card-content>
      <md-table v-model="sortedReservations" class="accommodation-reservations">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell
            md-label="Confirmed"
            md-id="manifest-reservation-confirmed"
            class="compact-column centered-column"
          >
            <md-switch v-model="item.confirmed"></md-switch>
          </md-table-cell>
          <md-table-cell
            md-label="Booked"
            md-id="manifest-reservation-booked"
            class="compact-column centered-column"
          >
            <md-switch v-model="item.booked"></md-switch>
          </md-table-cell>
          <md-table-cell
            md-label="Invoice in Xero"
            md-id="manifest-reservation-paid"
            class="compact-column centered-column"
          >
            <md-switch v-model="item.paid"></md-switch>
          </md-table-cell>
          <md-table-cell md-label="Night of" class="compact-column">
            <span v-if="item.date">{{ item.date | getDayFromDate }}</span>
          </md-table-cell>
          <md-table-cell md-label="Date" class="col-date">
            <md-field class="reservation-date">
              <md-input v-model="item.date" type="date"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell
            md-label="Twin"
            md-tooltip="Twin Room"
            class="small-number"
          >
            <md-field>
              <md-input v-model="item.room_type_twin" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell
            md-label="Double"
            md-tooltip="Double Room"
            class="small-number"
          >
            <md-field>
              <md-input v-model="item.room_type_double" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell
            md-label="Single"
            md-tooltip="Single Room"
            class="small-number"
          >
            <md-field>
              <md-input v-model="item.room_type_single" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell
            md-label="Family"
            md-tooltip="Family Room"
            class="small-number"
          >
            <md-field>
              <md-input v-model="item.room_type_family" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Hotel" class="flexible-column">
            <md-field class="option-select">
              <md-input
                :value="getReservationSearch(item)"
                :list="accommodationListId"
                @input="setReservationSearch(item, $event)"
                @change="applyReservationSearch(item)"
                @blur="applyReservationSearch(item)"
              ></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Notes" class="flexible-column">
            <md-field>
              <md-input v-model="item.notes" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell
            md-label="Actions"
            md-id="manifest-reservation-actions"
            class="compact-column centered-column"
          >
            <md-button
              class="md-danger md-just-icon md-simple"
              @click.stop="removeItem(item)"
            >
              <md-icon>delete</md-icon>
              <md-tooltip md-direction="top">Remove Entry</md-tooltip>
            </md-button>
          </md-table-cell>
        </md-table-row>
        <md-table-empty-state
          md-label="Nothing to Show"
          :md-description="`We can't find any details to show.`"
        >
        </md-table-empty-state>
      </md-table>
      <datalist :id="accommodationListId">
        <option
          v-for="accom in accommodation"
          :key="accom.id"
          :value="accom.company"
        ></option>
      </datalist>
      <reservation-actions
        :departure-id="departure && departure.id"
        section="reservations"
        :rows.sync="manifest.reservations"
        :prepare="prepareReservations"
      />
    </md-card-content>
  </md-card>
</template>

<script>
import ReservationActions from "./ReservationActions.vue";
import accomApi from "@/services/api/accom";
import moment from "moment";
import { getMissingDepartureDates } from "@/helpers/reservations";

export default {
  components: { ReservationActions },
  props: {
    manifest: {
      itinerary: [],
      dinners: [],
      reservations: []
    },
    departure: {}
  },

  data() {
    return {
      accommodation: [],
      reservationSearchMap: new WeakMap()
    };
  },

  computed: {
    accommodationListId() {
      return `accommodation-list-${this._uid}`;
    },

    sortedReservations() {
      return this.manifest.reservations
        .slice()
        .sort((a, b) => (Date.parse(a.date) || 0) - (Date.parse(b.date) || 0));
    }
  },

  methods: {
    addAllDays() {
      const existingDates = (this.manifest.reservations || []).map(
        reservation => reservation.date
      );
      getMissingDepartureDates(
        this.departure.start_date,
        this.departure.end_date,
        existingDates
      ).forEach(this.addDay);
    },

    addDay(date = null) {
      this.manifest.reservations.push({
        date: date ? moment().format(date) : moment().format("YYYY-MM-DD"),
        accommodation_id: null,
        confirmed: false,
        booked: false,
        paid: false,
        room_type_twin: "0",
        room_type_double: "0",
        room_type_single: "0",
        room_type_family: "0",
        notes: ""
      });
    },

    removeItem: function(item) {
      this.manifest.reservations.splice(
        this.manifest.reservations.indexOf(item),
        1
      );
    },

    setReservationSearch(item, value) {
      this.reservationSearchMap.set(item, value);
    },

    getReservationSearch(item) {
      if (this.reservationSearchMap.has(item)) {
        return this.reservationSearchMap.get(item);
      }
      if (!item.accommodation_id || !this.accommodation.length) return "";
      const match = this.accommodation.find(
        accom => accom.id === item.accommodation_id
      );
      return match ? match.company : "";
    },

    applyReservationSearch(item) {
      const search = (this.getReservationSearch(item) || "")
        .trim()
        .toLowerCase();
      if (!search) {
        item.accommodation_id = null;
        return;
      }
      const match = this.accommodation.find(
        accom => accom.company?.toLowerCase() === search
      );
      item.accommodation_id = match ? match.id : null;
    },

    prepareReservations() {
      this.manifest.reservations.forEach(item => {
        if (this.reservationSearchMap.has(item))
          this.applyReservationSearch(item);
      });
    }
  },

  created() {
    accomApi.getAccoms().then(response => {
      this.accommodation = response.data || [];
    });
  }
};
</script>

<style lang="scss" scoped>
.compact-column,
.small-number {
  width: 1%;
  white-space: nowrap;
}

.small-number .md-field,
.flexible-column .md-field {
  width: 100%;
  min-width: 0;
}

.small-number ::v-deep .md-input,
.flexible-column ::v-deep .md-input {
  flex: 1 1 0;
  width: 0;
  min-width: 0;
}
.col-date {
  width: 1%;
  white-space: nowrap;
}

.reservation-date {
  width: max-content;
  min-width: 0;
}

.reservation-date ::v-deep .md-input {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
}

.flexible-column {
  width: 50%;
  min-width: 10rem;
}

.accommodation-reservations ::v-deep .md-table-head .md-table-head-label,
.accommodation-reservations
  ::v-deep
  #manifest-reservation-actions
  .md-table-head-label {
  padding-right: 0;
}

.centered-column ::v-deep .md-table-cell-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.centered-column .md-switch,
.centered-column .md-button {
  margin: 0;
}

.accommodation-reservations ::v-deep #manifest-reservation-confirmed,
.accommodation-reservations ::v-deep #manifest-reservation-booked,
.accommodation-reservations ::v-deep #manifest-reservation-paid,
.accommodation-reservations ::v-deep #manifest-reservation-actions {
  text-align: center;
}
</style>
